<angular-editor [(ngModel)]="htmlContent" [config]="config"></angular-editor>

<pre>
    {{htmlContent}}
</pre>